import { createSlice } from '@reduxjs/toolkit';

export const errors = createSlice({
  name: 'ERRORS',
  initialState: [],
  reducers: {
    setApplicationError(state, action) {
      // For known errors, we can show a helpful message to a customer along with incrementing a datadog metric to aid with tracking this kind of behaviour.
      const { applicationError } = action.payload;
      return {
        ...state,
        applicationError,
      };
    },
  },
});

const { actions, reducer } = errors;

export const { setApplicationError } = actions;

export default reducer;
